import { useQuery } from "@tanstack/react-query";
import { subscriptionApi } from "../api";

export { clearSubscriptionApiCache } from "../api";

export const usePlans = () => {
	return useQuery({
		queryKey: ["plans"],
		queryFn: subscriptionApi.getPlans,
		staleTime: 1000 * 60 * 60, // 1 hour
	});
};

export const useSubscription = () => {
	return useQuery({
		queryKey: ["subscription"],
		queryFn: subscriptionApi.getSubscription,
		staleTime: 0,
		refetchOnMount: "always",
	});
};
